import type { Point } from "../scene/model";
import { drawBox, pointBounds, type Box } from "./geometry";
export interface SelectionRegion {
  kind: "rectangle" | "circle" | "lasso";
  box: Box;
  points: Point[];
  feather: number;
}
export function createRegion(
  kind: SelectionRegion["kind"],
  start: Point,
  end: Point,
  points: Point[],
  feather: number,
): SelectionRegion {
  return {
    kind,
    box:
      kind === "lasso"
        ? pointBounds(points)
        : drawBox(start, end, kind !== "circle", false),
    points: points.map((p) => ({ ...p })),
    feather: Math.max(0, Math.min(100, feather)),
  };
}
